import React, { useState } from 'react';
import { ShowMore } from 'screens/ShortlistPage/styled';
import * as Styled from './styled';
import ChevronUp from 'assets/svg/chevron-up.svg';
import LeadingIcon from 'assets/svg/circle-wavy-check.svg';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { useLocale } from 'locale';
import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { useRoute } from 'react-router5';
import { Route } from 'config/routes';
import { Description } from '../../components/Description';


export interface AboutDescriptionProps {
  title: string;
  description: string;
  subtitle?: string;
  isLeading?: boolean;
  officeName?: string;
  officeLogoUrl?: string;
  officeId?: string;
}

const MAX_CONTENT_LENGTH_MOBILE = 710;

export const AboutDescription: React.FC<AboutDescriptionProps> = (props) => {
  const {
    title,
    description,
    subtitle,
    isLeading = false,
    officeName,
    officeLogoUrl,
    officeId,
  } = props;
  const isMobile = useScreenBreakpoint() === 1;
  const { t } = useLocale();
  const [ isOpen, setIsOpen ] = useState(false);
  const { route } = useRoute();
  const isOfficePage = route.name === Route.OfficePage;
  const showOfficeData = Boolean(officeName && officeLogoUrl && officeId);

  return (
    <Styled.AboutSectionWrapper>
      <Styled.DescriptionTitle data-acc-heading={isOfficePage ? 'h2' : undefined} noMargin={Boolean(subtitle) && !isMobile}>
        {isMobile ? t('mortgage.officePage.subMenu.item', { item: isOfficePage ? Section.ABOUT : Section.AGENT_ABOUT }) : title}
        {!isMobile && isLeading ? <LeadingIcon /> : null}
      </Styled.DescriptionTitle>
      {subtitle && !isMobile ? <Styled.Subtitle>{subtitle}</Styled.Subtitle> : null}
      {!isMobile && showOfficeData ? (
        <Styled.OfficeWrapper>
          <Styled.OfficeLogoBox routeName={Route.OfficePage} routeParams={{ id: officeId, source: 'agent_page' }} hideLinkParams><img src={officeLogoUrl} /></Styled.OfficeLogoBox>
          <Styled.OfficeName weight="bold">{officeName}</Styled.OfficeName>
        </Styled.OfficeWrapper>
      ) : null}
      <Styled.DescriptionText>
        {isMobile ? (
          <>
            <span style={{ whiteSpace: 'normal' }} dangerouslySetInnerHTML={{ __html: description ? description.slice(0, isOpen ? undefined : MAX_CONTENT_LENGTH_MOBILE) : '' }} />
            {description && description.length > MAX_CONTENT_LENGTH_MOBILE ? (
              <Styled.ShowMoreWrapper isOpen={isOpen}>
                <ShowMore onClick={() => setIsOpen(!isOpen)}>
                  <>{t(isOpen ? 'collapsable.showLess' : 'collapsable.showMore')}<ChevronUp/></>
                </ShowMore>
              </Styled.ShowMoreWrapper>
            ) : null}
          </>
        ) : (
          <Description
            content={description}
            showOnClick
            maxLines={4}
          />
        )}
      </Styled.DescriptionText>
    </Styled.AboutSectionWrapper>
  );
};
